import {
  EventEmitter,
  Injectable,
  InjectionToken,
  inject,
} from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { CareType } from '@models/common/care-type.model';
import { CommonVerbsApiService } from '@services/common/common-verbs-api.service';
import { Community } from '@models/communities/community.model';
import { Corporation } from '@models/corporations/corporation.model';
import { Form } from '@models/forms/form.model';
import { FormSection } from '@models/account/forms/form-section.model';
import { MigFormData } from '@models/forms/mig-form-data.model';
import { Router } from '@angular/router';
import { User } from '@models/account/user.model';
import { isEmpty } from 'lodash';
export const IMigFormService = new InjectionToken<MigFormService>(
  'IMigFormService'
);
@Injectable()
export class MigFormService {
  api = inject(CommonVerbsApiService);
  router = inject(Router);

  onSubmit = new EventEmitter();
  onPrevious = new EventEmitter();

  corporation$ = new BehaviorSubject<Corporation | null>(null);
  communities$ = new BehaviorSubject<Community[]>([]);
  community$ = new BehaviorSubject<Community | null>(null);
  user$ = new BehaviorSubject<User | null>(null);
  careTypes$ = new BehaviorSubject<CareType[]>([]);
  form$ = new BehaviorSubject<Form | null>(null);
  sections$ = new BehaviorSubject<FormSection[]>([]);

  step: number;

  initial$ = new BehaviorSubject<MigFormData | null>(null);

  constructor() {
    this.onPrevious.subscribe(() => {
      console.log('onPrevious');

      switch (this.step) {
        case 1:
          this.router
            .navigateByUrl(`/mig-form/${this.corporation$.value?.code}`)
            .then();
          break;
        case 2:
          this.router
            .navigateByUrl(`/mig-form/${this.corporation$.value?.code}/wizard`)
            .then();
          break;
      }
    });
  }

  get storageIndex() {
    let path = 'mig-form';
    if (this.corporation$.value)
      path = `mig-form-${this.corporation$.value.id}`;
    return path;
  }

  get storage() {
    const storage = localStorage.getItem(this.storageIndex);
    return storage ? (JSON.parse(storage) as MigFormData) : null;
  }

  clearStorage(): void {
    localStorage.removeItem(this.storageIndex);
  }

  setStorage(filter: any) {
    this.clearStorage();
    if (!isEmpty(filter))
      localStorage.setItem(this.storageIndex, JSON.stringify(filter));
  }
}
